module.exports = __webpack_public_path__ + "img/play.3508a1cc.svg";